import { Text } from '../../../../../../../../components/ToolkitV2/Text/Text';

import { Container } from './Guide.styled';

import { type ThemeTypes } from '../../../../../../../../types/Theme.namespace';

type GuideProps = {
  header: string;
  body: string;
  footer: string;
  backgroundColor: ThemeTypes.Colors;
};

const Guide = (props: GuideProps) => {
  const { header, body, footer, backgroundColor } = props;

  return (
    <Container backgroundColor={backgroundColor}>
      <Text forwardedAs="h3" weight="semibold" size="M16">
        {header}
      </Text>
      <Text weight="bold" size="H32" color="GREY_DARKER">
        {body}
      </Text>
      <Text>{footer}</Text>
    </Container>
  );
};

export { Guide };
